/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Example_CaptionInputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_2_example_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Example_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter each expression in the cell shown. B6 is 15 before the edit and 25 afterward.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_example_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Example_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在对应单元格输入右侧内容。B6 在修改前为 15，修改后为 25。`)
};

/**
* | output |
* | --- |
* | "Enter each expression in the cell shown. B6 is 15 before the edit and 25 afterward." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Example_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_2_example_caption = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Example_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Example_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_2_example_caption(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_example_caption(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_2_example_caption as "gc.search_guides.gridcraft_excel_compatibility.sections.2.example.caption" }